module.exports = __webpack_public_path__ + "static/img/about-blob.bf97dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-blob.png
// module id = l5W0
// module chunks = 0